import React from "react";
import "./Submission.scss";
function Submission() {
  return (
    <div className="Submission">
      <div className="tools-challenge">
        {/* <h2>Submission Format & Evaluation Metrics</h2> */}

        <h2>Submission</h2>
        <p>
          Every team is required to submit the Docker images for evaluation. At
          most 3 runs are allowed and 1 of the 3 is selected as the primary run
          of the submission. When submitting, each team should specify 3 URLs at
          most for us to download their images.
        </p>
        <p>The format of the output CSV file is as follows.</p>
        <p className="indent">
          <em>{"<Test video name1>,"}</em>
          <em> {"<Anomalous event name>,"} </em>
          <em> {" <Start frame id>,"} </em>
          <em> {"<End frame id>"} </em>
        </p>
        <p>
          Each line of the CSV file is the annotation for a video, containing a
          video name followed by the name of the anomalous event as well as the
          starting and ending frame of the event.
        </p>
        <p>An example is as follows:</p>
        <p className="indent">
          <em>test_000.mp4, fighting, 145, 203</em>
        </p>
        <p className="indent">- The first column is the name of the video.</p>
        <p className="indent">
          - The second column is the name of the anomalous event, selected from
          [accident, carrying, crowd, explosion, fighting, graffiti, robbery,
          shooting, smoking, stealing, sweeping, walkingdog] for specific
          anomaly detection task or [abnormal] for general anomaly detection
          task.
        </p>
        <p className="indent">
          - The third column is the starting frame of the event which starts
          from 0.
        </p>
        <p className="indent">
          - The fourth column is the ending frame of the event which starts form
          0.
        </p>
        <p>
          If a video contains multiple instance of an anomalous event, the
          format is as follows:
        </p>
        <p className="indent">
          <em>{"<Test video name1>,"}</em>
          <em>{"<Anomalous event name>,"} </em>
          <em>{"<Start frame id1>,"}</em>
          <em>{"<End frame id1>,"}</em>
          <em>{"<Start frame id2>,"}</em>
          <em>{"<End frame id2>"}</em>
        </p>
        <p>
          If a video contains various anomalous events, the format is as
          follows:
        </p>
        <p className="indent">
          <em> {"<Test video name1>,"} </em>
          <em> {"<Anomalous event name1>,"} </em>
          <em> {" <Start frame id>,"} </em>
          <em> {"<End frame id>"}</em>
        </p>
        <p className="indent">
          <em> {"<Test video name1>,"} </em>
          <em> {"<Anomalous event name2>,"}</em>
          <em> {"<Start frame id>,"}</em>
          <em> {"<End frame id>"} </em>
        </p>
        <p>
          If a video do not contain any anomalous event, the format is as
          follows:
        </p>
        <p className="indent">
          <em> {"<Test video name1>"} , Normal, -1, -1 </em>
        </p>

        <h2>How You Should Prepare the Image</h2>
        <p>
          We recommend each team bases their Docker image on Ubuntu: 16.04 or
          above and test their solution on it. Once the image is ready for
          submission, the following steps should be performed:
        </p>
        <p className="indent">
          {`1. docker commit --change 'ENTRYPOINT ["<main_executable>"]' <container_id> <their_image>`}
        </p>
        <p className="indent">
          {`2. docker save <their_image> | gzip -c > <saved_image_file>`}
        </p>
        <p className="indent">
          {`3. upload the file to Google Drive and submit the downloadable URL to us`}
        </p>
        <p>
          {
            "In command (1), the <main_executable> should be an executable, e.g., bash script, which accepts 2 arguments described below."
          }
        </p>
        <p>
          A sample image can be found at
          <a href="mailto:https:shorturl.at/DER67"> https:shorturl.at/DER67</a>
        </p>
        <p>{`The example docker image use the script 'ENTRYPOINT["/bin/bash","/home/example.sh"]' as the entry point which provide a demonstration of the inputs and outputs of the container.
              The competitors can provide their commands to use the executable to perform the algorithm such as python with the mainstream deep learning framework.
            `}</p>

        <h2>How We Run the Image</h2>
        <p className="indent">{`1. curl -L -o <downloaded_image> <url>`}</p>
        <p className="indent">{`2. docker load < <downloaded_image>`}</p>
        <p className="indent">
          {`3. docker run --gpus all --network none -ti -v <testset_path>:/testset:ro -v /result --name <container_name> <their_image> /testset /result/predictions.csv`}
        </p>
        <p className="indent">{`4. docker cp <container_name>:/result/predictions.csv <all_results_path>`}</p>
        <p>Note that:</p>
        <li className="indent">Command (3) accepts 2 arguments</li>
        <li className="indent">The image is run under GPU mode</li>
        <li className="indent">There is NO internet access in the container</li>
        <li className="indent">
          Command (4) copies the produced CSV file to our local path so that we
          can do the evaluation.
        </li>
        <li className="indent">
          The total execution time MUST NOT exceed 1 hour. A score of 0 will be
          assigned if the execution does not produce the expected results or the
          execution exceeds 1 hour.
        </li>
        <p>
          Please remember to test your image with these commands before
          submitting.
        </p>

        <h2>Evaluation Environment</h2>
        <li className="indent">
          Intel(R) Xeon(R) CPU E5-2682 v4 @ 2.50GHz, 16 vCPUs
        </li>
        <li className="indent">DDR4 memory, 118GB</li>
        <li className="indent">
          Tesla P100 PCIe 16GB ×2(Driver Version: 410.129)
        </li>
        <li className="indent">Docker version 19.03.5</li>
        <p>
          For any question related to the evaluation part, please contact:
          Xiangyu Wang
          <a href="mailto:david.wxy@alibaba-inc.com">
            (david.wxy@alibaba-inc.com).
          </a>
        </p>
      </div>
    </div>
  );
}

export default Submission;
